import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

export default function Landing() {
  return (
    <div className="landing-container">
      <div className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span>Danify</span> Studio
          </h1>
          <p className="hero-subtitle">
            Transform yourself into anything. Real-time AI video editing, avatar animation, and creative tools.
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary">Get Started</Link>
            <Link to="/login" className="btn btn-secondary">Sign In</Link>
          </div>
        </div>
        <div className="hero-graphic">
          <img src="/hero-placeholder.png" alt="Hero" className="hero-image" />
        </div>
      </div>
      <div className="features">
        <div className="feature-card">
          <div className="feature-icon"><i className="fas fa-user-astronaut"></i></div>
          <h3>Character Swap</h3>
          <p>Swap faces or transform into any character in real-time with AI.</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon"><i className="fas fa-user-circle"></i></div>
          <h3>Avatar Live</h3>
          <p>Animate a portrait image with audio and expressions.</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon"><i className="fas fa-image"></i></div>
          <h3>Image Generation</h3>
          <p>Create stunning images from text prompts.</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon"><i className="fas fa-video"></i></div>
          <h3>Video Generation</h3>
          <p>Generate videos from text or animate images.</p>
        </div>
      </div>
    </div>
  );
}
